import React from "react";
import { useTranslation } from 'react-i18next';
import MfaVerificationForm from "../../../containers/user-management/MfaVerificationForm/MfaVerificationForm";
import {
  Wrapper,
  Header,
  SubTitle,
  Text,
  Card,
  BackLink,
  Logo
} from "../styles";
import PageWrapper from "../../../components/PageWrapper/PageWrapper";
import LanguageDropdown from "../../../components/LanguageDropdown";

const MfaVerificationPage = () => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <LanguageDropdown />
      <Wrapper>
        <Header>
          <Logo src="/logo.png" alt="Offolio Logo" />
          <SubTitle>{t('mfaVerificationPage.title')}</SubTitle>
          <Text>{t('mfaVerificationPage.subtitle')}</Text>
        </Header>

        <Card>
          <MfaVerificationForm />
        </Card>
      </Wrapper>
    </PageWrapper>
  );
};

export default MfaVerificationPage;
